import { Component } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { InstallMspAppBadgesComponent } from 'mbs-ui-shared@components';

@Component({
  selector: 'mbs-install-msp-app-instruction',
  templateUrl: './install-msp-app-instruction.component.html',
  standalone: true,
  imports: [InstallMspAppBadgesComponent, I18NextModule]
})
export class InstallMspAppInstructionComponent {}
